import React from "react";
import styled from "styled-components";
import Map from "../../assets/img/map.png";
import Phone from "../../assets/img/phone.png";
import Send from "../../assets/img/send.png";

const Container = styled.div`
  height: 90%;
  background: url("https://image.similarpng.com/very-thumbnail/2020/08/Set-colorful-social-media-doodle-texture-design-Clipart-PNG.png")
    center left fixed no-repeat;
  background-size: cover;
  @media only screen and (max-width: 480px) {
    height: 80%;
  }
`;

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media only screen and (max-width: 480px) {
    height: 100%;
    flex-direction: column;
    justify-content: center;
    padding: 0px;
  }
`;

const FormContainer = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media only screen and (max-width: 480px) {
    width: 100%;
    margin-left: 10px;
  }
`;

const Title = styled.h1`
  margin: 50px;
  margin-top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  text-align: center;
  @media only screen and (max-width: 480px) {
    margin: 10px;
    font-size: 20px;
  }
`;

const Form = styled.form`
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media only screen and (max-width: 480px) {
    flex-direction: column;
  }
`;

const LeftForm = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 20px;
  @media only screen and (max-width: 480px) {
    height: 50%;
    margin-right: 0;
  }
`;

const RightForm = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media only screen and (max-width: 480px) {
    height: 50%;
  }
`;

const Input = styled.input`
  width: 200px;
  padding: 20px;
  @media only screen and (max-width: 480px) {
    padding: 5px;
  }
`;

const TextArea = styled.textarea`
  width: 200px;
  height: 60%;
  padding: 20px;
  @media only screen and (max-width: 480px) {
    padding: 5px;
    margin-top: 20px;
  }
`;

const Button = styled.button`
  border: none;
  padding: 15px;
  background-color: darkblue;
  color: white;
  font-size: 20px;
  border-radius: 10px;
  margin-top: 20px;
  cursor: pointer;

  &:hover {
    background-color: blue;
  }
  @media only screen and (max-width: 480px) {
    padding: 5px;
    font-size: 14px;
  }
`;

const AddressContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 200px;
  z-index: 2;
  @media only screen and (max-width: 480px) {
    width: 100%;
    margin-top: 20px;
    padding-left: 100px;
  }
`;

const AddressItem = styled.div`
  margin-bottom: 50px;
  @media only screen and (max-width: 480px) {
    margin-bottom: 10px;
  }
`;

const Icon = styled.img`
  width: 20px;
  margin-right: 20px;
  @media only screen and (max-width: 480px) {
    width: 15px;
  }
`;

const Text = styled.span`
  font-size: 20px;
  margin-right: 15px;

  @media only screen and (max-width: 480px) {
    font-size: 14px;
  }
`;

const LinkRel = styled.a`
  text-decoration: none;
  text-transform: uppercase;
  font-size: 15px;
  color: white;
`;

const Contact = () => {
  return (
    <Container id="Contact">
      <Wrapper>
        <FormContainer>
          <Title>
            Questions? <br /> Let's Get In Touch
          </Title>
          <Form>
            <LeftForm>
              <Input placeholder="Your Name" />
              <Input placeholder="Your Email" />
              <Input placeholder="Subject" />
            </LeftForm>
            <RightForm>
              <TextArea placeholder="Your Message" />
              <Button>
                <LinkRel href="mahmoudayed@hotmail.fr">Send</LinkRel>
              </Button>
            </RightForm>
          </Form>
        </FormContainer>
        <AddressContainer>
          <AddressItem>
            <Icon src={Map} />
            <Text>5070 Ksar Hellal, Monastir, TUNISIA</Text>
          </AddressItem>
          <AddressItem>
            <Icon src={Phone} />
            <Text>+216.51.547.900</Text>
          </AddressItem>
          <AddressItem>
            <Icon src={Send} />
            <Text>Mahmoudayed@hotmail.fr</Text>
          </AddressItem>
        </AddressContainer>
      </Wrapper>
    </Container>
  );
};

export default Contact;
